import { action, makeObservable, observable, runInAction } from 'mobx';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';

export class DeleteStreamWindowState
  extends StoreNode {

  readonly nodeType = 'DeleteStreamWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      submit: action,
      handleSubmitFinally: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;

  streamId?: string | null;
  streamName?: string | null;

  async submit() {
    this.isLoading = true;

    const [, err] = await this.store.apiService.archiveJob({ id: this.streamId || '' });

    if (err) {
      notifyError(this, 'Could not delete the video.');
      return this.handleSubmitFinally();
    }

    runInAction(() => {
      notifySuccess(this, 'Stream deleted.');
      this.emit('streamDeleted')

      // TODO: decouple from widget/page — use an event or service to trigger job list refresh
      this.store.widgetService.isWidgetMode ?
        this.store.liveStreamQueueWidget.refreshJobs() :
        this.store.liveStreamQueuePage.refreshJobs();

      this.handleSubmitFinally();
    });
  }


  handleSubmitFinally() {
    this.isLoading = false;
    this.close();
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ streamId, streamName }: { streamId: string, streamName?: string }) {
    this.dispatch('Overlays', 'openWindow', { name: 'DeleteStreamWindow' });

    this.streamId = streamId;
    this.streamName = streamName;
  }

  close() {
    this.streamName = null;
    this.streamId = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}